export const initialState = {};

const railsContext = (state = initialState) => {
  return state;
};

export default railsContext;
